module.exports = __webpack_public_path__ + "static/media/image-background-subcriptions@2x.aca6f195.png";